import PluginIconSvg from './plugin-icon-svg';
import PluginSvgMold from './plugin-svg-mold';
import CountryCallingCodePicker from './country-calling-code-picker';
import SweetPluginStepDialog from './sweet-plugin-step-dialog';

const Plugins = [
  PluginIconSvg,
  PluginSvgMold,
  CountryCallingCodePicker,
  SweetPluginStepDialog,
];

const install = (Vue) => {
  Plugins.forEach((plugin) => {
    Vue.component(plugin.name, plugin);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  PluginIconSvg,
  PluginSvgMold,
  CountryCallingCodePicker,
  SweetPluginStepDialog,
};
